<script>
	import {replace} from "svelte-spa-router";
	import {onMount,beforeUpdate} from "svelte";
	import ItemLocal from "../componentes/itemLocal.svelte";
	import Controlador from "../controlador.svelte";
	import {docs,logueo} from "../store.js";
	let c;
	let locales = [];
	onMount(()=>{	
		if (!$logueo){
			replace('/');
		}
	})
	beforeUpdate(()=>{
		if (locales){
			locales = [];
			$docs.forEach((el)=>{
				if (el._id.includes("local:")){
					let item = {
						nombre: (el.nombre == "Guemes"? "Güemes" : el.nombre),
						id: el._id
						};
					if (item.nombre != "Güemes"){
						locales.push(item); 
					}
				}
			});
			$docs.forEach((el)=>{
				if (el._id.includes("local:")){
					if (el.nombre == "Guemes"){
						let item = {
							nombre: (el.nombre == "Guemes"? "Güemes" : el.nombre),
							id: el._id
						};
						locales.push(item);
					}
				}
			})
        }

	})
</script>
<Controlador bind:this={c} />
<div class="p-4 w-full sm:w-3/4 flex flex-col">
	<div class="flex w-full items-center">
		<a href="#/home" class="w-full bg-red-500 rounded shadow text-white m-2 p-2 cursor-pointer flex items-center justify-center hover:bg-red-300 hover:shadow-2">
			<i class="ri-arrow-left-line" />
			Volver
		</a>
	</div>
	<div class="p-4 sm:p-2 w-full flex flex-col items-center justify-start sm:grid sm:grid-cols-2 sm:grid-rows-auto sm:gap-2">
		{#each locales as local}
			<ItemLocal local={local} />
		{/each}
	</div>
</div>
